/**
 * IntelMethodologyPanel
 *
 * Static reference: what Intel is, how cross-project patterns emerge, what to look for
 */
export function IntelMethodologyPanel(): React.ReactElement {
  return (
    <div className="space-y-2">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-text-tertiary">
        What is Intel?
      </div>
      <div className="space-y-1.5 text-[10px] text-text-secondary">
        <div>
          <span className="font-semibold text-text-primary">Cross-Project Synthesis</span> shows how
          patterns flow across your entire portfolio — shared problems, proven solutions, emerging
          methodologies.
        </div>
        <div>
          <span className="font-semibold text-text-primary">Shared Patterns</span> highlight
          categories where multiple projects converge. These reveal organization-wide strengths and
          opportunities for standardization.
        </div>
        <div>
          <span className="font-semibold text-text-primary">Phase Distribution</span> groups
          projects by delivery lifecycle — shows balance, bottlenecks, and where to focus support.
        </div>
        <div className="pt-1 border-t border-border/50">
          Use Intel to guide strategic decisions: where to invest in tooling, which patterns to
          promote across teams, and how to grow methodology at scale.
        </div>
      </div>
    </div>
  );
}
